import { LayoutDashboard } from "lucide-react";
import { useTranslation } from "@/shared/providers/LanguageProvider";
import { DashboardPageHeader } from "@/shared/ui/DashboardPageHeader";
import {
  AdminDashboardSectionLabel,
  AdminKeyIndicators,
  AdminQuickLinks,
} from "../components/admin-widgets/AdminDashboardSections";
import { InvoiceDistributionChart } from "../components/admin-widgets/InvoiceDistributionChart";
import { MonthlyVolumeChart } from "../components/admin-widgets/MonthlyVolumeChart";
import { SystemStatsWidget } from "../components/admin-widgets/SystemStatsWidget";
import { RecentActivityWidget } from "../components/admin-widgets/RecentActivityWidget";
import { PlatformMetricsWidget } from "../components/admin-widgets/PlatformMetricsWidget";
import { SubmittedInvoicesTable } from "../components/admin-widgets/SubmittedInvoicesTable";
import { useAdminDashboard } from "../hooks/useAdminDashboard";

export function AdminDashboardPage() {
  const { t } = useTranslation();
  const labels = t.safecheck.adminDashboard;
  const { data, loading, error } = useAdminDashboard();
  const summary = labels.summary
    .replace("{invoices}", String(data.summary.totalInvoices))
    .replace("{admissions}", String(data.summary.admissions));

  return (
    <div className="space-y-5">
      <DashboardPageHeader
        title={labels.pageTitle}
        subtitle={summary}
        icon={LayoutDashboard}
        badge={data.header.roleBadge || labels.badge}
        date={data.header.displayDate}
      />

      {error ? (
        <p className="rounded-lg border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700">
          {error}
        </p>
      ) : null}
      {loading ? <p className="text-sm text-muted">Chargement…</p> : null}

      <div>
        <AdminDashboardSectionLabel>{labels.keyIndicators}</AdminDashboardSectionLabel>
        <AdminKeyIndicators indicators={data.indicators} />
      </div>

      <div>
        <AdminDashboardSectionLabel>{labels.sections.quickAccess}</AdminDashboardSectionLabel>
        <AdminQuickLinks />
      </div>

      <div>
        <AdminDashboardSectionLabel>{labels.sections.charts}</AdminDashboardSectionLabel>
        <div className="grid grid-cols-1 gap-5 lg:grid-cols-2">
          <InvoiceDistributionChart data={data.invoiceDistribution} />
          <MonthlyVolumeChart />
        </div>
      </div>

      <SystemStatsWidget stats={data.systemStats} />

      <div>
        <AdminDashboardSectionLabel>{labels.sections.activity}</AdminDashboardSectionLabel>
        <div className="grid grid-cols-1 gap-5 lg:grid-cols-2">
          <RecentActivityWidget />
          <PlatformMetricsWidget />
        </div>
      </div>

      <div>
        <AdminDashboardSectionLabel>{labels.sections.invoices}</AdminDashboardSectionLabel>
        <SubmittedInvoicesTable rows={data.submittedInvoices} />
      </div>
    </div>
  );
}
